/**
 * Removes only the outermost <div> tags if they wrap the entire content.
 * Does not remove inner <div>s or their content.
 * Example:
 *   Input: <div>Text before<div>Inner content</div>Text after</div>
 *   Output: Text before<div>Inner content</div>Text after
 * Example:
 *   Input: <div>Text before</div><div>Inner content</div>Text after
 *   Output: <div>Text before</div><div>Inner content</div>Text after
 */
export const cleanDivWrapper = (html: string): string => {
  // Trim whitespace to avoid issues with spacing outside the div
  const trimmed = html.trim();

  // Check if the content starts with a single outer <div> and ends with </div>
  if (trimmed.startsWith('<div') && trimmed.endsWith('</div>')) {
    // Use a DOMParser to accurately check if it's a single outer <div> wrapping everything
    const parser = new DOMParser();
    const doc = parser.parseFromString(trimmed, 'text/html');
    const body = doc.body;

    // If the body contains exactly one element and it's a div
    if (
      body.children.length === 1 &&
      body.firstElementChild?.tagName.toLowerCase() === 'div'
    ) {
      // Return the inner HTML of that div
      return (body.firstElementChild as HTMLElement).innerHTML;
    }
  }

  // Return original if it's not a single outer <div>
  return html;
};
